import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";
import TextWithTip from "../../../components/TextWithTip";
import NamedEntity from "../../../interfaces/NamedEntity";

interface PickerProps {
	currentOption: NamedEntity | null;
	options: NamedEntity[];
	label: string;
	navigateURL: string;
	onClick: (selected: NamedEntity) => void;
}

export default function Picker(props: PickerProps) {
	return (
		<Menu as="div" className="relative">
			<div>
				<MenuButton
					disabled={props.options.length == 1}
					id={`${props.label}-menu-button`}
					className="text-white font-medium underline underline-offset-4 decoration-1 cursor-pointer rounded-md bg-white/0 px-3 py-2 hover:bg-white/10 max-w-[240px]">
					<TextWithTip
						uniqueName={"districtName"}
						text={props.currentOption?.name ?? props.label}
					/>
				</MenuButton>
			</div>
			<Transition
				as={Fragment}
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95">
				<MenuItems className="border border-gray-200 bg-white absolute right-0 divide-y divide-gray-100 rounded-md min-w-[240px] z-50 overflow-hidden">
					<div>
						{props.options
							.filter((item) => {
								return item.id !== props.currentOption?.id;
							})
							.map((item) => {
								return (
									<MenuItem key={item.id}>
										{() => (
											<span
												onClick={() => props.onClick(item)}
												className={`flex items-center px-4 py-3 text-sm text-gray-800 hover:text-gray-700 hover:bg-gray-100`}>
												<span>{item.name}</span>
											</span>
										)}
									</MenuItem>
								);
							})}
					</div>
					<SeeAllMenuItem navigateURL={props.navigateURL} label={props.label} />
				</MenuItems>
			</Transition>
		</Menu>
	);
}

interface SeeAllMenuItemProps {
	navigateURL: string;
	label: string;
}

export function SeeAllMenuItem(props: SeeAllMenuItemProps) {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		location.pathname !== props.navigateURL && (
			<div className="text-center">
				<MenuItem key={`${props.label}-page`}>
					<span
						onClick={() => navigate(props.navigateURL)}
						className="block px-4 py-3 text-sm text-primary-800 hover:text-primary-700 hover:bg-gray-100">
						See all {props.label}...
					</span>
				</MenuItem>
			</div>
		)
	);
}
